import { Component, Input } from '@angular/core';
import { FormArray, Validators } from '@angular/forms';
import { SafariObjectId } from '@safarilaw-webapp/shared/common-objects-models';

import { ReduxFormId } from '../../../../../enums';
import { FormSubmitInfo, SafariFormComponent, SafariValidators } from '@safarilaw-webapp/shared/ui-kit/safari-form';

export class FolderInfo {
  id: SafariObjectId;
  folders: { name: string }[];
}
@Component({
  selector: 'sl-lpms-update-subfolder-dialog-form',
  templateUrl: './update-subfolder-dialog-form.component.html',
  styleUrls: ['./update-subfolder-dialog-form.component.scss'],
  imports: [SafariFormComponent.standaloneImports]
})
export class UpdateSubfolderDialogFormComponent extends SafariFormComponent<FolderInfo> {
  @Input()
  invalidNames: string[] = [];

  @Input()
  shouldShowAddSubfolderNameButton: boolean;

  constructor() {
    super();
    this.componentId = ReduxFormId.UpdateOrCreateFolder;
  }

  onModelBound(): void {
    this.createForm({
      folders: this.formBuilder.array([])
    });

    this.addFolderName(this.appModel.folders[0]?.name || '');

    this.setFocusOnNewSubfolderName();
  }

  onSubmit(submitInfo: FormSubmitInfo<FolderInfo>) {
    submitInfo.appModel = { ...submitInfo.appModel, ...submitInfo.formModel };

    return super.onSubmit(submitInfo);
  }

  setFocusOnNewSubfolderName(index = 0) {
    setTimeout(() => {
      const element = document.getElementById('folder-name' + index.toString());
      if (element) {
        element.focus();
      }
    }, 100);
  }
  addFolderName(name = '') {
    this.foldersArray.push(
      this.formBuilder.group({
        name: this.formBuilder.control(name, [
          Validators.required,
          Validators.maxLength(100),
          SafariValidators.noControlValueCollisionInArray('name', 'Folder name must be unique!'),
          SafariValidators.canNotSetValue(this.invalidNames || [], 'Folder name already exists!')
        ])
      })
    );
    this.setFocusOnNewSubfolderName(this.foldersArray.controls.length - 1);
  }
  removeFolderName(i) {
    this.foldersArray.removeAt(i);
  }
  get foldersArray(): FormArray {
    return this.form.get('folders') as FormArray;
  }
}
